import { render, staticRenderFns } from "./TradingUnit.vue?vue&type=template&id=4b5795e0"
import script from "./TradingUnit.vue?vue&type=script&lang=js"
export * from "./TradingUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports